import { FuseLoadable } from '@fuse';
import Authorize from '../../Authorize';

export const profileConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/profile',
      component: Authorize(FuseLoadable({
        loader: () => import('./Profile')
      }))
    },
    {
      path: '/profile/:current_tab',
      component: Authorize(FuseLoadable({
        loader: () => import('./Profile')
      }))
    }
  ]
};
